import * as React from "react"
import {Grid, Skeleton} from "@mui/material";


export default function PriceEvolutionTabsLoadingBlock() {
    return <Grid container spacing={2}>
        <Grid item xs={4}>
			<Skeleton variant="rectangular" height={90}/>
		</Grid>

		<Grid item xs={4}>
			<Skeleton variant="rectangular" height={90}/>
		</Grid>

		<Grid item xs={4}>
			<Skeleton variant="rectangular" height={90}/>
		</Grid>
    </Grid>
}